import { Company, Office } from "@/api/company-api";

export default function buildEndUserData(company: Company, office: Office) {
  const d = new FormData();
  d.append("id", company.companyId);
  d.append("companyTypeId", String(company.companyTypeId));
  d.append("client", String(company.client));
  d.append("vendor", String(company.vendor));
  d.append("family", String(company.family));
  d.append("name", company.name);
  d.append("furigana", company.furigana);
  d.append("office[id]", office.officeId);
  d.append("office[name]", "(エンドユーザー)");
  d.append("office[tel1]", office.tel1);
  d.append("office[tel2]", office.tel2);
  d.append("office[fax]", office.fax);
  d.append("office[mail]", office.mail);
  d.append("office[postcode]", office.postcode);
  d.append("office[address]", office.address);
  d.append("office[latitude]", String(office.latitude));
  d.append("office[longitude]", String(office.longitude));
  d.append("office[note]", office.note);
  d.append("office[cutoffRule]", String(office.cutoffRule));
  d.append("office[monthRule]", String(office.monthRule));
  d.append("office[dayRule]", String(office.dayRule));
  d.append("office[profitRate]", String(office.profitRate));
  d.append("office[invoiceNumber]", String(office.invoiceNumber || ''));

  return d;
}
